/**
 * Grid alignment Script
 */
{
    window.setGridHeight = (selector) => {
      let gridOffsets = [];
      let gridRowOffsets = []
  
      gridOffsets = Array.from(document.querySelectorAll(selector)).map((element,index) => {
        let grid = element.closest('.js-card-wrapper') || element.closest('[data-equal]');
        element.removeAttribute('style');
        return {
          selector:element,
          selectorHeight: element.offsetHeight,
          offsetTop: grid.offsetTop,
        }
      });
  
      let offsets = gridOffsets.map(element => element.offsetTop);
      gridRowOffsets = [...new Set(offsets)];
  
      gridRowOffsets.forEach(rowOffset => {
        let rowGrids = gridOffsets.filter(grid => (grid.offsetTop == rowOffset));
        let comanElementHeight = Math.max.apply(Math,(rowGrids.map(ele => ele.selectorHeight)));
        rowGrids.forEach(grid => {
          grid.selector.style.minHeight = comanElementHeight+'px';
        });
      });
    }
  
   setTimeout(() => {
      window.matchHeightCallback();
    }, 2000)
    
    window.addEventListener('resize', function(event){
      window.matchHeightCallback();
    });
  
    window.matchHeightCallback = () => {
      window.setGridHeight('.js-grid-content-height'); 
    }
    window.matchHeightCallback();
}

let gridButton = document.querySelectorAll('.js-handle-grid-height');
if(gridButton.length > 0) {
  gridButton.forEach((button) => {
    button.addEventListener('click', () => {
      window.matchHeightCallback();
    })
  })
}